import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { log } from "console";

export interface IfillZero {
  combination_id: string;
}

const fillZeroMain = async (combId: string): Promise<IfillZero | boolean> => {
  try {

    const config: AxiosRequestConfig = {
      method: "POST",
      // url: `${process.env.REACT_APP_HOST}/ultra3/add-entry`, http://ultra-cib.malihetz.complete-inbox.com
      // url: `https://quiz-back.firebird.rs/api/ultra/fill-zero-main`,
      
      // Lokalno (development)
      // url: `http://localhost:6002/api/ultra/fill-zero-main`,
      
      // Produkcija
      url: `https://politehnika-back.firebird.rs/api/ultra/fill-zero-main`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        combId: combId,
      },
    };
    const response: AxiosResponse = await axios(config);
    const { data } = response.data;


    return data;
  } catch (error) {

    return false;
  }
};

export default fillZeroMain;
